module.exports = __webpack_public_path__ + "static/media/rupee-icon.c33244c4.png";